/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */

/**
 * Localstorage key for storing names of cache databases
 *
 * @type {string}
 *
 */

export const dbListKey = 'mgt-db-list';
